// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const moltres_galar: PokeData = {
  "id": 10171,
  "name": "moltres-galar",
  "height": 20,
  "weight": 660,
  "base_experience": 290,
  "types": [
    PokeType.DARK,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "wing-attack",
    "leer",
    "agility",
    "sky-attack",
    "endure",
    "safeguard",
    "ancient-power",
    "memento",
    "payback",
    "sucker-punch",
    "air-slash",
    "nasty-plot",
    "after-you",
    "hurricane",
    "fiery-wrath"
  ],
  "moves": [
    "gust",
    "leer",
    "sky-attack",
    "ancient-power",
    "air-slash",
    "hurricane",
    "quash",
    "snatch",
    "night-daze",
    "dark-pulse",
    "bite",
    "tailwind",
    "pursuit"
  ],
  "evolution_chain": {
    "id": 75,
    "item": null,
    "species": [
      {
        "name": "moltres",
        "order": 178,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 137,
    "speed": 125,
    "ability_power": 139
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
